import { FaExclamationCircle } from 'react-icons/fa';
import InputComponent from '../../components/InputComponent';
import TextareaComponent from '../../components/TextareaComponent';

// SCSS
import '../../assets/scss/sectionThree.scss';

const SectionThree = ({ register, formData, handleChange }) => {
	return (
		<div className='sectionThree flex-col'>
			<div className='flex-row'>

				<div className='flex-row'>
					<div className='landingpage'>
						<InputComponent
							label={<span>Link til landingsside</span>}
							type='text'
							name='landingpage'
							placeholder='f.eks. www.firma.no eller https://…'
							inputMode='url'
							autoComplete='url'
							register={register}
							onChange={(e) => handleChange(e.target.name, e.target.value)}
						/>
					</div>

					<div className='soknadsfrist'>
						<InputComponent
							label='Søknadsfrist'
							type='date'
							name='soknadsfrist'
							register={register}
							onChange={(e) => handleChange(e.target.name, e.target.value)}
						/>
					</div>
				</div>

			</div>




			<div className='feed flex-row' style={{ marginTop: '24px' }}>
				<TextareaComponent
					label='Feed-tekst til innlegg'
					name='feed-text'
					className='feed-text-innlegg'
					placeholder='Skriv inn tekst til feed til innlegg'
					maxLength='120'
					register={register}
					counter={false}
				/>
				<small >
					- FB viser kun de 3 øverste linjene før man må trykke
					"se mer" i selve teksten. Det er plass til ca. 120 tegn
					på de tre linjene (inkl. mellomrom) Det viktigste
					budskapet bør derfor komme frem først. <br />
					<br />- Bruk "Kundenavn søker", <u>IKKE</u> "vi søker".{' '}
					<br />
					<br />- Skriv med et direkte språk til brukeren "du/deg
					ikke vi/vårt".
					<FaExclamationCircle size='28' />
				</small>
			</div>


		</div>
	);
};

export default SectionThree;
